import React from "react";
import { useMemo, useState } from "react";
import style from "./CustomForm.module.css";
import EjectIcon from "@mui/icons-material/ArrowForwardIos";
import ErrorIcon from "@mui/icons-material/Error";
import OTPInput from "otp-input-react";

function BoxedInput(props) {
  const [showErr, setShowErr] = useState(false);

  useMemo(() => {
    if (props.value) {
      if (props.value.length < props.length) {
        setShowErr(`${props.name} should be ${props.length} digits`);
        props.isValid(false);
      } else {
        setShowErr(false);
        props.isValid(true);
      }
    } else {
      setShowErr(`Please fill ${props.name}  field`);
      props.isValid(false);
    }
    props.setShowErrOnBlur(false);
  }, [props.value]);

  return (
    <>
      <div className={style.inputTPIN_container}>
        <div className={style.inputTPIN_container_Inner}>
          <p className={style.BoxedInput_label}>{props.label}</p>
          <br />
          <OTPInput
            className={style.inputTPIN}
            value={props.value}
            onChange={props.setter}
            hasError={true}
            autoFocus
            OTPLength={props.length}
            otpType="number"
            min={1}
            disabled={false}
            secure
          />
        </div>
        <p
          className={`${style.error} ${
            showErr && props.showErrOnBlur ? style.showError : style.hideError
          }`}
        >
          <p>
            <EjectIcon />
            <ErrorIcon />
            {showErr}
          </p>
        </p>
      </div>
    </>
  );
}

export default BoxedInput;
